import { judgeAcmg } from '@/@core/layouts/utils'
import { extractFirstNumber, formatDate, isJson } from '@/@core/utils/utils'

export const getTemplate5 = (
  report: any,
  reportValue: any,
  reportsVariants: any[],
  reportsVariantsType: any,
  samples: any[],
  t: any
) => {
  return [
    {
      type: 'block-title',
      children: [
        {
          text: '/images/logos/genomelight_logo.png'
        }
      ]
    },
    {
      type: 'header2-color',
      children: [
        {
          text: '遗传病基因检测咨询报告'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '基本信息'
        }
      ]
    },
    {
      type: 'box-blackborder',
      children: [
        {
          type: 'header3-genetic-krd2',
          children: [
            {
              text: '1.受检者'
            }
          ]
        },
        {
          type: 'table-available',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      text: `姓名：${reportValue.patient?.patientName ?? '-'}`
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      text: `性别：${t(
                        (reportValue?.patient?.gender as string) ?? '-'
                      )}`
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      text: `年龄：${
                        reportValue.patient?.dateOfBirth
                          ? (Math.floor(
                              (new Date().valueOf() -
                                new Date(
                                  reportValue.patient?.dateOfBirth
                                ).valueOf()) /
                                3.15576e10
                            ) <= 0
                              ? 0
                              : Math.floor(
                                  (new Date().valueOf() -
                                    new Date(
                                      reportValue.patient?.dateOfBirth
                                    ).valueOf()) /
                                    3.15576e10
                                )) + '岁'
                          : '-'
                      }`
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      text: `联系方式：${reportValue.patient?.phone ?? '-'}`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'header3-genetic-krd2',
          children: [
            {
              text: '2.临床信息'
            }
          ]
        },
        {
          type: 'paragraph-2',
          children: [
            {
              text: `诊断：${samples
                .map((items) => {
                  if (items && items.sample) {
                    const terms = items.sample.terms

                    if (terms && isJson(terms)) {
                      return JSON.parse(terms)
                    } else if (Array.isArray(terms)) return terms

                    return []
                  }

                  return []
                })
                .flat()
                .map(
                  (item, index) => `${index}.${item.name_cn}(${item.hpo_code})`
                )
                .join(';')}`
            }
          ]
        },
        {
          type: 'divider',
          children: [
            {
              text: ``
            }
          ]
        },
        {
          type: 'paragraph-2',
          children: [
            {
              text: `临床症状及家族史：${reportValue.sample?.clinicalInformation}`
            }
          ]
        },
        {
          type: 'divider',
          children: [
            {
              text: ``
            }
          ]
        },
        {
          type: 'header3-genetic-krd2',
          children: [
            {
              text: '3.样本及送检信息'
            }
          ]
        },
        {
          type: 'table-available',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    { text: `样本编号：${reportValue.sample?.id ?? '-'}` }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'span',
                      children: [{ text: '样本类型：' }]
                    },
                    {
                      type: 'check-box',
                      children: [{ text: '' }]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    { text: `病历号：${reportValue.patient?.caseNumber}` }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      text: `送检医院：${reportValue.patient?.infirmaryName}`
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      text: `科室：${reportValue.patient?.departmentName} `
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [{ text: '床号：-' }]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      text: `采样日期：${
                        formatDate(
                          reportValue.sample?.annotatedStart,
                          'YYYY/MM/DD'
                        ) ?? '-'
                      }`
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      text: `接收日期：${
                        formatDate(
                          reportValue.sample?.createdAt,
                          'YYYY/MM/DD'
                        ) ?? '-'
                      }`
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      text: `报告日期：${
                        formatDate(report.createdAt, 'YYYY/MM/DD') ?? '-'
                      }`
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'header3-genetic-krd2',
          children: [
            {
              text: '4.检测项目信息'
            }
          ]
        },
        {
          type: 'paragraph-2',
          children: [
            {
              text: `检测项目：-`
            }
          ]
        },
        {
          type: 'divider',
          children: [
            {
              text: ``
            }
          ]
        },
        {
          type: 'paragraph-2',
          children: [
            {
              text: `检测方法：目标区域捕获高通量测序`
            }
          ]
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '检测结果'
        }
      ]
    },
    {
      type: 'box-blackborder',
      children: [
        {
          type: 'header3-krd',
          children: [
            {
              text: '检测结论'
            }
          ]
        },
        {
          type: 'paragraph-2',
          children: [
            {
              type: 'span-blod-red',
              children: [
                {
                  text: '检出与受检者临床症状相关的变异'
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter((item) => item.variantsType === 'KeyFinding')
          .map((item) => {
            return {
              type: 'paragraph-2',
              children: [
                {
                  text: `${item.gene}基因：${item.OMIMCN}`
                }
              ]
            }
          })
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '检测结果统计'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '主要检测结果：与症状可能相关的变异'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic-r2-krd',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(转录本)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-r2-krd',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '亚区'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-r2-krd',
              children: [{ text: '突变信息' }]
            },
            {
              type: 'table-cell-color-genetic-r2-krd',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '突变'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '类型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-r2-krd',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '致病性'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '分类'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-r2-krd',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '遗传'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '方式'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-r2-krd',
              children: [{ text: '疾病/表型' }]
            },
            {
              type: 'table-cell-color-genetic-r2-krd',
              children: [{ text: 'RS号' }]
            },
            {
              type: 'table-cell-color-genetic-c2-krd',
              children: [{ text: '家系验证' }]
            },
            {
              type: 'table-cell-color-genetic-r2-krd',
              children: [{ text: '文献' }]
            },
            {
              type: 'table-cell-color-genetic-r2-krd',
              children: [{ text: '类型' }]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic-krd',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '父亲' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-krd',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '母亲' }]
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter((item) => item.variantsType === 'KeyFinding')
          .map((row) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.gene
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.transcript
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${row.var_location}`
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${row.exon}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${row.nuc_change}`
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.c_nomen
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.p_nomen
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.allele_frequency
                            ? row.allele_frequency < 0.85
                              ? t('heterozygote')
                              : t('homozygote')
                            : '无'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: judgeAcmg(
                            row.user_acmg_classification
                              ? row.user_acmg_classification
                              : row.ACMG_classification
                              ? row.ACMG_classification
                              : row.classification
                              ? row.classification
                              : ''
                          )
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.inheritance
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.OMIMCN ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${row.rs_id}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `未检测`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `未检测`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '2'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: t(row.variantsType)
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          }),
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-c12',
              children: [
                {
                  type: 'paragraph-small',
                  children: [
                    {
                      text: '备注：'
                    }
                  ]
                },
                {
                  type: 'paragraph-small',
                  children: [
                    {
                      text: '1.数据解读规则参考美国医学遗传学和基因组学学院（American College of Medical Genetics and Genomics，ACMG）相关指南。变异命名参照HGVS建议的规则给出（http://www.hgvs.org/mutnomen/）。'
                    }
                  ]
                },
                {
                  type: 'paragraph-small',
                  children: [
                    {
                      text: '2.遗传方式：AD，常染色体显性遗传；AR，常染色体隐性遗传；XLD，X染色体显性遗传；XLR，X染色体隐性遗传；-，遗传方式未明。'
                    }
                  ]
                }
              ]
            }
          ]
        },
        ...reportsVariants
          .filter((item) => item.variantsType === 'KeyFinding')
          .map((item) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-c12',
                  children: [
                    {
                      type: 'p5-genetic-value',
                      children: [
                        {
                          text: `     本次检测，在受检者中检出 ${
                            item.gene
                          }基因有1个变异：${item.c_nomen}:${
                            item.p_nomen
                          }（编码区第${extractFirstNumber(
                            item.c_nomen
                          )}号核苷酸由胸腺嘧啶变异为胞嘧啶，导致第${extractFirstNumber(
                            item.p_nomen
                          )}号氨基酸由异亮氨酸变异为苏氨酸），为杂合错义突变。该突变在gnomAD 东亚人群数据库中频率报道为${
                            item.gnomAD_exome_ALL
                          }。该位点被ClinVar数据库收录为${
                            item.CLINSIG_final
                          }[1]。`
                        }
                      ]
                    },
                    {
                      type: 'p5-genetic-value',
                      children: [
                        {
                          text: `     ${item.gene}基因相关的疾病：`
                        }
                      ]
                    },
                    {
                      type: 'p5-genetic-value',
                      children:
                        item.newOMIMData && item.newOMIMData.length
                          ? item.newOMIMData?.map((i: any) => {
                              return {
                                type: 'paragraph',
                                children: [
                                  {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'h3',
                                        text: `${i.genetic_mode ?? '-'}--${
                                          i.disease
                                        }`
                                      }
                                    ]
                                  },
                                  {
                                    type: 'paragraph',
                                    text: `${
                                      i?.disease_description_cn ??
                                      t('No Results')
                                    }`
                                  }
                                ]
                              }
                            })
                          : item.OMIMData && item.OMIMData.length
                          ? item.OMIMData?.map((i: any, index: any) => {
                              return {
                                type: 'paragraph',
                                children: [
                                  {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'h3',
                                        text: `${index + 1}:${
                                          i.pheno_name_cn ?? '-'
                                        }`
                                      }
                                    ]
                                  },
                                  {
                                    type: 'paragraph',
                                    text: `     ${
                                      i.phenoDescriptionCNStr.join('\n')
                                        ? i.phenoDescriptionCNStr.join('\n')
                                        : t('No Results')
                                    }`
                                  }
                                ]
                              }
                            })
                          : item.MitoMap && item.MitoMap.disease_ch
                          ? [
                              {
                                type: 'paragraph',
                                children: [
                                  {
                                    type: 'paragraph',
                                    children: [
                                      {
                                        type: 'h3',
                                        text: `${
                                          item.MitoMap.disease_ch ?? '-'
                                        }`
                                      }
                                    ]
                                  },
                                  {
                                    type: 'paragraph',
                                    text: `${
                                      item.MitoMap.info ?? t('No Results')
                                    }`
                                  }
                                ]
                              }
                            ]
                          : [
                              {
                                text: ''
                              }
                            ]
                    }
                  ]
                }
              ]
            }
          })
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: ``
        }
      ]
    },
    {
      type: 'block-patient-info',
      children: [
        {
          type: 'p3-dashed-20',
          children: [
            {
              text: `检验者：`
            }
          ]
        },
        {
          type: 'p3-dashed-20',
          children: [
            {
              text: ``
            }
          ]
        },
        {
          type: 'p3-dashed-20',
          children: [
            {
              text: `报告者：`
            }
          ]
        },
        {
          type: 'p3-dashed-20',
          children: [
            {
              text: ``
            }
          ]
        },
        {
          type: 'p3-dashed-20',
          children: [
            {
              text: `2024-9-11`
            }
          ]
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '检测基因列表'
        }
      ]
    },
    {
      type: 'box-blackborder',
      children: [
        {
          type: 'header3-krd',
          children: [
            {
              text: '检测基因'
            }
          ]
        },
        {
          type: 'paragraph-2',
          children: [
            {
              text: `ADAR,ADCY5,ADORA1,AIRE,ANG,ANO3,APTX,ATM,ATP13A2,ATP1A3,ATP6AP2,ATP7A,ATP7B,AXIN1,BRAF,C19orf12,CA2,CHCHD10,CHCHD2,CHMP2B,CIZ1,CNR1,CNR2,COASY,COL4A1,COL6A3,CACNA1G,CP,CTC1,CYP27A1,DAGLA,DAGLB,DCAF17,DCTN1,DDRGK1,DNAJC12,DNAJC13,DNAJC6,DRD1,DRD2,DRD3,DRD5,DST,ECHS1,ECM1,EIF4EBP1,EIF4G1,ERCC6,ERCC8,FA2H,FBXO7,FBXW7,FMR1,FOLR1,FTL,FUS,GALC,GATA3,GBA,GCDH,GCH1,GFAP,GIGYF2,GJD2,GLUD2,GNAL,GRN,HAPLN4,HPCA,HS1BP3,HTRA2,IFIH1,IL1B,INPP5F,ISG15,KCNS2,KMT2B,LINGO1,LRRK2,MAPT,MTHFR,NALCN,NEFH,NPC1,NPC2,NR4A2,NUS1,OPTN,PACRG,PANK2,PARK7,PDE8B,PDGFB,PDGFRB,PINK1,PLA2G6,PNKD,PODXL,POLG,PRKN,PRKRA,PRRT2,PSEN1,PSEN2,PTRHD1,RAB29,RAB39B,RIC3,RNASEH2A,RNASEH2B,RNASEH2C,SAMHD1,SERAC1,SERPINA3,SGCE,SIGMAR1,SIPA1L2,SLC19A3,SLC1A2,SLC1A4,SLC20A2,SLC2A1,SLC30A10,SLC6A3,SMPD1,SNCA,SETX,SORT1,SPR,SQSTM1,STK32B,SYNJ1,TAF1,TARDBP,TBCE,TBK1,TENM4,TH,THAP1,TIMM8A,TMEM230,TOR1A,TOR1B,TREM2,TREX1,TUBB4A,TYROBP,UBQLN2,UCHL1,USP46,VCP,VPS13C,VP S35,WDR45,XPR1,ZFYVE26等${reportValue.sample?.totalGenes}个基因`
            }
          ]
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '目标区域捕获高通量测序数据质控'
        }
      ]
    },
    {
      type: 'box-center',
      children: [
        {
          type: 'table',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '受检者姓名'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-padding',
                      children: [
                        {
                          text: `${reportValue.patient?.patientName ?? '-'}`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '目标基因数'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-padding',
                      children: [
                        {
                          text: `${reportValue.sample?.totalGenes}个`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '目标区域长度（bp）'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-padding',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '目标区域覆盖度'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-padding',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '目标区域平均深度（X）'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-padding',
                      children: [
                        {
                          text: `${reportValue.sample?.avgReadDepth}`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '目标区域平均深度>20X位点所占比例'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'p3-center-padding',
                      children: [
                        {
                          text: '-'
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '检测方法与局限性'
        }
      ]
    },
    {
      type: 'box-blackdashedborder',
      children: [
        {
          type: 'block-gls-footer',
          children: [
            {
              type: 'span-blod',
              children: [
                {
                  text: '检测方法：'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '目标区域捕获高通量测序。本方法通过收集受检者血液、唾液或其他组织来源的DNA样本为检测材料，对基因组DNA进行打断并制备文库，通过液相芯片对目标基因的外显子及邻近剪切区域的DNA进行捕获和富集，最后通过高通量测序平台进行变异检测。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        },
        {
          type: 'block-gls-footer',
          children: [
            {
              type: 'span-blod',
              children: [
                {
                  text: '检测方法局限性：'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '高通量检测技术适用于检测基因外显子及邻近±20bp区域内的点突变及小的缺失插入突变。不适于检测基因调节区域和深度内含子区域的突变。不能检测染色体数目及结构异常、某些DNA大片段的缺失、DNA大片段拷贝数变异以及动态突变、复杂重组等特殊类型突变。此外由于部分基因存在高重复、低复杂度区域，以至检测不能完全覆盖其所有外显子区，但总体覆盖度可达95%以上。且高重复、低复杂度区域、假基因影响的基因等会对检测结果判定会产生一定的影响。为确保结果准确性，二代测序项目检出的可能有临床意义的点突变、插入缺失突变建议进行一代测序(Sanger测序法)验证。对于嵌合型的突变，如变异比例较低（<25%），难以检出。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        },
        {
          type: 'block-gls-footer',
          children: [
            {
              type: 'span-blod',
              children: [
                {
                  text: '检测方法局限性举例：'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '部分基因受假基因影响，导致捕获基因检测结果不可靠，例如：SMN1、CYP21A2、PKD1等。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '碱基修饰改变（如甲基化等）导致的疾病，例如：Prader-Willi综合征、Angelman综合征等。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '三核苷酸动态突变引起的疾病，例如：亨廷顿舞蹈病、脊髓小脑性共济失调3型、肯尼迪病等。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '无法覆盖面肩肱型肌营养不良症相关的D4Z4重复数改变。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '深度内含子区域、基因表达调控区域（5’UTR、3’UTR）区域、非编码RNA，由于目前缺乏对其进行分析的有效手段，不在本次检测内容范围内。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        },
        {
          type: 'block-gls-footer',
          children: [
            {
              type: 'span-blod',
              children: [
                {
                  text: '临床特点局限性：'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '本次检测根据受检者主诉，对应OMIM中已知明确的单基因遗传病致病基因进行分析。多基因易感疾病相关基因、复杂疾病相关基因不包含在此次分析在内。若受检者选择分析指定的基因，则非指定基因不在本次分析范围内。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '本报告仅限于受检者临床表型相关且与受检者家族遗传病史不冲突的致病/疑似致病/意义不明确的变异。实验室无法对医生或受检者提供的临床表型及临床怀疑疾病的真实性、准确性、全面性做出保证。由于临床表型和家族史提供不准确或不完善的样本存在报告位点提报不精确的风险。本报告不排除在该受检者的基因组中存在其他致病性的改变。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        },
        {
          type: 'block-gls-footer',
          children: [
            {
              type: 'span-blod',
              children: [
                {
                  text: '注：'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '*本报告结果只对送检样品负责。本中心对以上检测结果保留最终解释权，如有疑义，请在收到结果后的7个工作日内与我们联系。以上结论为实验室检测数据，仅用于突变检测之目的，不代表最终诊断结果，仅供临床参考。由于疾病的复杂性和进展性以及每种检测技术方法的局限性，本次检测仅仅提供检测范围内的变异情况。委托方已充分了解该诊断研究的性质和风险，经本人及家属慎重考虑后同意接受实验分析，实验分析方已履行了告知义务。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '*如果先证者报告结果为以下两种情况，其相关亲属不再做Sanger测序进行固定位点验证。（仅针对单基因遗传病中两例家属免费验证的报告）。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '1:阴性结果。'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: '2:临床体征、家族病史无关的VUS位点'
                }
              ]
            },
            {
              type: 'paragraph-2',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '数据分析'
        }
      ]
    },
    {
      type: 'box-blackdashedborder',
      children: [
        {
          type: 'paragraph-2',
          children: [
            {
              text: '使用AfterQC对原始测序数据进行测序质量评估，并去除低质量以及被接头污染的reads。将过滤后的数据使用BWA软件（Burrows Wheeler Aligner）与人类hg19参考基因组进行序列比对，而后对捕获效果进行评估。使用GATK软件(Genome Analysis Toolkit)分析基因组中SNV（single nucletide variant）和Indel（insertion and deletion）。随后使用人群数据库1000 Genomes(1000 human genome dataset)、Genome AD(Genome Aggregation Database dataset) 2.1.1及 ExAC(The Exome Aggregation Consortium dataset)对分析得到的SNV及Indel进行筛选。使用dbNSFP数据库对错义突变及剪切突变的致病性进行预测。使用人类孟德尔遗传数据库（OMIM）、人类基因突变数据库（HGMD）及Clinvar数据库对已报道的突变进行筛查。将所有突变位点使用ACMG遗传变异分类标准与指南进行分类。最后对所有可能的致病位点使用Sanger测序的方法进行验证。'
            }
          ]
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '其他突变'
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: '注：其他隐性遗传(AR)杂合突变（理论上必须在两个等位基因均出现突变才可能致病）或与个人临床无明确关联的基因变异。'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic-krd',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '(转录本)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-krd',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '基因'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '亚区'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-krd',
              children: [{ text: '突变信息' }]
            },
            {
              type: 'table-cell-color-genetic-krd',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '突变'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '类型'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-krd',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '致病性'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '分类'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-krd',
              children: [
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '遗传'
                    }
                  ]
                },
                {
                  type: 'p4-center',
                  children: [
                    {
                      text: '方式'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-krd',
              children: [{ text: '疾病/表型' }]
            },
            {
              type: 'table-cell-color-genetic-krd',
              children: [{ text: 'RS号' }]
            },
            {
              type: 'table-cell-color-genetic-krd',
              children: [{ text: '类型' }]
            }
          ]
        },
        ...reportsVariants
          .filter((item) => item.variantsType !== 'KeyFinding')
          .map((row) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.gene
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.transcript
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${row.var_location}`
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${row.exon}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${row.nuc_change}`
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.c_nomen
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.p_nomen
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.allele_frequency
                            ? row.allele_frequency < 0.85
                              ? t('heterozygote')
                              : t('homozygote')
                            : '无'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: judgeAcmg(
                            row.user_acmg_classification
                              ? row.user_acmg_classification
                              : row.ACMG_classification
                              ? row.ACMG_classification
                              : row.classification
                              ? row.classification
                              : ''
                          )
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.inheritance
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.OMIMCN ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${row.rs_id}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: t(`${row.variantsType}`)
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          })
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: '遗传方式：AD，常染色体显性遗传；AR，常染色体隐性遗传；XLD，X 染色体显性遗传；XLR，X 染色体隐性遗传；-，遗传方式未明。'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '遗传病'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '遗传病的分类及分子基础'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     由于基因突变或染色体数目或结构变异导致的疾病称为遗传病（genetic disease）。从人类遗传物质的改变情况分类，遗传病总体上可分为六大类：'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '     染色体病'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     由于染色体数目或结构异常而引起的临床综合征。通常分为常染色体病和性染色体病两大类。临床上最常见的唐氏综合征属于常染色体数目异常，即第21号染色体多了一条，成为21三体。染色体病通常不在家系中传递，但也有可传递的，例如染色体平衡易位携带者。目前已知的染色体病有 300种以上。在自然'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     流产胎儿中有 20～50％是由染色体异常所致，而新生儿中染色体异常的发生率达到 0.5～1％。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '     单基因病'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     由1个或1对等位基因突变所导致的遗传病。单基因病可分为常染色体显性、常染色体隐性、X 连锁显性、X 连锁隐性遗传病及 Y 连锁遗传病等几大类。现在我们熟知的一些遗传病如色盲、血友病、地中海贫血等，很多都属于单基因病。单基因病通常呈现特征性的家系传递模式。其分类如下：'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          常染色体显性遗传病'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     致病基因位于常染色体上的两个等位基因中，如有一个突变，这个突变基因的异常效应就能显示发病。这类疾病已达1700多种，如家族性多发性结肠息肉。多指、并指等。其遗传系谱特点是；遗传与性别无关，男女发病机会均等；患者双亲往往有一方为患者。若双亲无病，子女一般不发病；患者常为杂合型，若与正常人婚配,其子女患病概率为50%；常见连续几代的遗传。 显性致病基因有时由于内外环境的影响，杂合子个体携带显性致病基因并不表达，即不完全外显。常染色体显性遗传病的外显率为60%-90%。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          常染色体隐性遗传病'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     致病基因位于常染色体上的隐性基因，当隐性基因纯合时才能发病。即隐性遗传病患者，大多是由两个携带者所生的后代。已确定这类疾病约1200多种，如先天性聋哑、白化病、苯丙酮尿症。'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     杂合型隐性致病基因携带者，本身不表达相应的性状，但可将致病基因传给后代。'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     常染色体隐性遗传病的谱系特点：男女发病机会均等，发病与性别无关；双亲为无病携带者，子女发病概率为25%；常是越代遗传；近亲婚配时，子女中隐性遗传病患病率大为增高。如苯丙酮尿症在人群中随机婚配时,发病率为1:14500；表兄妹婚配则为1:1700。全身性白化病在人群中发病率为1:40000；表兄妹婚配则为1:3600。'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     性连锁遗传病多为隐性致病基因，位于X染色体上，男女发病率有显著差异如红绿色盲、血友病。已确定这类疾病近200种。致病基因一般是父传女,母传子，即所谓交叉遗传，患者可隔代出现，人群中男性患者远较女性患者为多。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          X连锁显性遗传病'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     X连锁显性遗传病病种较少，有抗维生素D性佝偻病等。这类病女性发病率高，这是由于女性有两条X染色体，获得这一显性致病基因的概率高之故，但病情较男性轻。男性患者病情重，他的全部女儿都将患病'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          X连锁隐性遗传病'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     致病基因在X染色体上，性状是隐性的，女性只是携带者，这类女性携带者与正常男性婚配，子代中的男性有1/2是概率患病，女性不发病，但有1/2的概率是携带者。男性患者与正常女性婚配，子代中男性正常，女性都是携带者。因此X连锁隐性遗传在患病系中常表现为女性携带，男性患病。男性的致病基因只能随着X染色体传给女儿，不能传给儿子，称为交叉遗传。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          Y连锁遗传病'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     Y连锁遗传病的特点是男性传递给儿子，女性不发病。因Y染色体上主要有男性决定因子方面的基因，其他基因很少，故Y连锁遗传病极少见。目前已经知道的Y伴性遗传的性状或遗传病比较少，肯定的有H－Y抗原基因、外耳道多毛基因和睾丸决定因子基因等。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '     多基因病'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     由多个等位基因控制其发生的疾病。多基因病除了受遗传因素控制之外，还受环境等多种复杂因素的影响。遗传度越高表示遗传因素起的作用越大，反之，则是说明环境因素所起作用越大。多基因病有家族聚集现象，但没有单基因病那样明确的家系传递模式。多基因病常常是环境与遗传交互作用的结果。高血压、糖尿病以及许多种先天畸形综合征均是常见的多基因遗传病。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '     线粒体病'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     线粒体病是指以线粒体功能异常为主要病因的一大类疾病。线粒体是细胞内氧化磷酸化和形成 ATP 的主要场所，因此有细胞内―动力工厂之称。线粒体病是因为线粒体代谢酶缺陷，使得ATP合成障碍、能量来源不足导致的一类疾病。而除线粒体DNA突变直接导致的疾病外，编码线粒体蛋白的核基因突变也可引起线粒体病，但这类疾病表现为孟德尔遗传方式。通常所指的线粒体病即线粒体DNA突变所致的线粒体功能异常。由于人体内几乎所有细胞的直接能量都来自于线粒体，因此线粒体病可以导致多系统功能的紊乱，而因中枢神经系统和骨骼肌对能量的依赖性最强，故临床症状以中枢神经系统和骨骼肌病变为特征。最常见的线粒体病有线粒体耳聋、Kearns-Sayre 综合征、Leigh 综合征等。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          母系遗传 '
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     指两个具有相对性状的亲本杂交，不论正交或反交，子一代总是表现为母本性状的遗传现象。母系遗传是细胞质遗传的主要特征。mtDNA只通过卵细胞将其中的遗传信息传给下一代，使得子代中线粒体DNA序列和母亲一致，即所谓的母系遗传。'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     均质突变：细胞线粒体中，所有线粒体DNA均发生突变；'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '     异质突变：细胞线粒体中，部分线粒体DNA发生突变'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '     体细胞遗传病（Somatic Cell Genetic Disorders）'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '      目前最常见的体细胞遗传病就是肿瘤。肿瘤起因于遗传物质的突变，不同个体中存在肿瘤遗传易感性的差异。另外，有些导致先天畸形的罕见病也属于体细胞遗传病。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '     特殊类型遗传病 '
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '      特殊类型的遗传病包括动态变异、复杂重组、甲基化异常等特殊的基因组异常导致的疾病。'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '术语解释'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '      遗传方式 '
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '      遗传方式指遗传信息传递的特点。通过分析亲代与子代遗传性状的相似及变异情况便可了解遗传方式。人类遗传方式主要分为单基因遗传方式和多基因遗传方式。在单基因遗传方式中又可以分为常染色体遗传方式和性染色体遗传方式。位于常染色体的单基因遗传方式遵从孟德尔遗传规律，而线粒体基因为母系遗传方式。'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          type: 'span-blod',
          children: [
            {
              text: '     基因 '
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: '（遗传因子）：指产生一条多肽链或功能RNA所需的全部核苷酸序列。基因支持着生命的基本构造和性能。储存着生命的种族、血型、孕育、生长、凋亡等过程的全部信息。环境和遗传的互相依赖，演绎着生命的繁衍、细胞分裂和蛋白质合成等重要生理过程。生物体的生、长、衰、病、老、死等一切生命现象都与基因有关。它也是决定生命健康的内在因素。因此，基因具有双重属性：物质性（存在方式）和信息性（根本属性）。带有遗传信息的DNA片段称为基因，其他的DNA序列，有些直接以自身构造发挥作用，有些则参与调控遗传信息的表现。 '
            }
          ]
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          type: 'span-blod',
          children: [
            {
              text: '     转录本 '
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: '（剪切体）：指由一条基因通过转录形成的一种或多种可供编码蛋白质的成熟的mRNA。'
            }
          ]
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '      突变与突变类型 '
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '      突变是指生物体、病毒或染色体外DNA基因组核苷酸序列的改变。包括哪怕是只有一个碱基变化的碱基替换、DNA插入、DNA缺失或DNA重复引起的序列的改变  。一些突变是可遗传的，生殖细胞发生的突变可以遗传给后代。发生在非生殖细胞即体细胞的突变，称为体细胞突变，是非遗传的突变。'
            }
          ]
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          按照基因结构改变分类 '
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          小规模突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '小规模突变影响基因中的一个或几个核苷酸 （只影响到一个核苷酸的突变称为点突变）。小规模突变包括：'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          type: 'span-blod',
          children: [
            {
              text: '     插入： '
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: '将一个或多个额外的核苷酸添加到DNA中。它们通常由转座因子引起，或由重复元件错误复制所致。位于基因编码区的插入可改变mRNA的剪接（剪接位点突变）或引起阅读框架的移位（移码），这两者都可显著改变基因产物。通过切除转座因子可以逆转插入。'
            }
          ]
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          type: 'span-blod',
          children: [
            {
              text: '     缺失： '
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: '从DNA中去除一个或多个核苷酸。像插入一样，这些突变可以改变基因的阅读框架。一般来说，它们是不可逆转的。'
            }
          ]
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          type: 'span-blod',
          children: [
            {
              text: '     替换： '
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: '通常由化学物质或DNA复制失常引起的替换突变将基因中的单个核苷酸替换为另一个核苷酸。最常见的是嘌呤和嘌呤或嘧啶与嘧啶间的替换，也称转换。不常见的是易位，也称颠换，它将嘌呤替换为嘧啶或将嘧啶替换为嘌呤。'
            }
          ]
        },
        {
          type: 'p5-genetic-value',
          children: [
            {
              text: '     点突变是基因内单个碱基对DNA或其它小碱基对的修饰。点突变可以通过另一个点突变逆转（其中核苷酸变回其原始状态，真正的逆转）或通过第二位点逆转（其它地方的互补突变导致重新获得基因功能）。在基因的蛋白质编码区内发生的点突变可分为同义或非同义替换，后者又可分为错义突变或无义突变。'
            }
          ]
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          大规模突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '大规模突变涉及到染色体结构的突变，包括：'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          type: 'span-blod',
          children: [
            {
              text: '     扩增： '
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: '（或基因复制）：导致染色体所有区域拷贝数增加，从而增加了染色体中基因的剂量。'
            }
          ]
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          type: 'span-blod',
          children: [
            {
              text: '     缺失： '
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: '大片段染色体缺失，导致该区域内基因的丢失。'
            }
          ]
        },
        {
          type: 'p5-genetic-value',
          children: [
            {
              text: '     染色体结构的大规模变化也称为染色体重排，这可能导致适应性降低，但也会导致孤立的近交种群的物种形成。常见的染色体重排有：1）染色体易位-部分遗传物质与非同源染色体发生交换。2）染色体倒位-染色体片段方向倒位。3）非同源染色体交叉。4）间质缺失：从单个染色体中去除一段DNA引起的染色体内缺失。5)杂合性缺失：在先前具有两个不同等位基因的生物中，通过缺失或遗传重组事件丢失了一个等位基因。'
            }
          ]
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          按照基因功能改变分类 '
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          功能丧失突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '也称失活突变，导致基因产物具有较少或完全没有功能（部分或完全失活）。当等位基因完全丧失功能（无效等位基因）时，它通常被称为无定形突变，与此类突变相关的表型通常是隐性的。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          功能获得性突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '也称为激活突变，改变的基因产物，使其功能变强（增强激活），甚至被不同的异常功能所取代。当新等位基因被创建时，含有新创建等位基因和原始等位基因的杂合子将表达新的等位基因。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          显性负突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '也称为抗形态突变，改变的基因产物与野生型等位基因产物的作用相拮抗。这些突变通常导致分子功能改变（通常无活性），并且以显性或半显性表型为特征。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          致死突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '导致携带突变生物死亡的突变。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          回复突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '也称逆转突变，是一种点突变，可恢复原始序列，从而恢复原始表型。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          移码突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '任何不能被3整除的插入或缺失引起的突变称为移码突变。由于密码子的三联体性质，插入或缺失破坏了阅读框或密码子的分组，从而导致与野生型完全不同的翻译。缺失或插入发生位置在序列中越靠前，引起的蛋白质变化越明显。相反，任何可被3整除的插入或缺失引起的突变称为整码突变。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          同义突变和非同义突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '点替换突变导致的单个核苷酸变化引起的突变可以是同义突变也可以是非同义突变。 同义替换突变将密码子替换为编码相同氨基酸的另一密码子，其最终的蛋白质序列没有改变。同义突变源于遗传密码的简并性。如果同义突变不导致任何表型变化，那么这种同义突变也被称为沉默突变。但并非所有同义突变都是沉默突变。'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '          非同义替换将密码子替换为编码不同氨基酸的另一密码子，从而产生经过改变的蛋白质。这种点突变称为非同义突变。非同义突变又可分为无义突变和错义突变。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          错义突变和无义突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '错义突变造成不同氨基酸的替代，可能使得到的蛋白质无功能。另一方面，如果错义突变导致替换使用不同但化学性质相似的氨基酸，则有时蛋白质很少或几乎没有变化。例如，从AAA到AGA的变化将导致从编码赖氨酸到编码精氨酸的变化，但精氨酸与赖氨酸化学性质相似。在这样一种情况下，突变对表型几乎没有影响，因此该突变是中性的。'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '          无义突变是导致产生终止密码子提前或在转录mRNA中产生无义密码子的点突变，因此，获得的蛋白质要么短，要么无功能。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          按照遗传性质改变的分类'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '在分化有生殖细胞的多细胞生物中，突变可以细分为生殖细胞突变和体细胞突变。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          生殖细胞突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '又称生殖系突变，是指可以通过其生殖细胞传递给后代的突变。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '          体细胞突变'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '又称获得性突变，是指发生于生殖细胞以外体细胞的突变，通常不会传递给后代。'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '遗传咨询意义'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '遗传咨询适用指征'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '遗传咨询是为患者或其家属提供与遗传疾病相关的知识或信息服务。此过程主要包括：通过对家族史的解释和医学发病史、遗传规律对疾病的发生和再发风险进行评估；对咨询者进行疾病的遗传、实验室检测、治疗处理及预防的教育，同时提供与疾病有关的各种治疗措施、求助的渠道和对研究方向的认知；辅导咨询者进行知情选择和对所患疾病及其再发风险的认知和接受。遗传咨询范围已从单纯的生育遗传咨询扩大到对包括常见肿瘤等具有遗传倾向疾病的咨询（对此类疾病，非指导性咨询原则已不适用）。而对咨询者进行疾病相关的遗传学内容的教育和研究信息被列入遗传咨询的范畴。'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '需进行遗传咨询的指征包括：'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '1、遗传学筛查和遗传学检测阳性者；'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '2、高龄孕妇（一般设定为>35 周岁）和曾怀有过遗传病的胎儿或生育过遗传病患儿的父母；'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '3、父母之一是遗传病患者或携带者；'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '4、反复发作的自发性流产或有长期不孕史的夫妻；'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '5、有遗传病家族史者；'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '6、近亲婚配者；'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '7、有明显环境致畸形物的接触史；'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '8、患有遗传因素相关的常见病如肿瘤等。'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '精准诊断的意义及必要性'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '精准诊断是指可识别出能解释罕见临床特征（表型）的精确分子致病基因（基因型）的诊断模式。病因学诊断是对症治疗的前提，因此精准诊断非常重要。本篇以遗传因素相关性最高的单基因遗传病为例，分享做基因检测的必要性以及检测意义。'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '基因检测可避免单基因遗传病误诊或漏诊'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '单基因遗传病就是由于基因突变引起，例如：Dravet综合征是由SCN1A基因突变引起的癫痫发作表现，而这种由基因突变所导致的疾病表型不通过基因检测根本无法明确病因。再如：皮质下带状灰质异位又称双皮质或经典的无脑回畸形，是一种罕见的神经元移行障碍导致的严重脑功能障碍性疾病。该病以癫痫、智力障碍、生长发育迟缓为主要表现。3岁以前患儿神经髓鞘发育不完全，异位灰质与正常灰质信号一致，由此头颅MRI对该病在婴幼儿阶段的诊断存在局限性，临床漏诊误诊率极高。通过基因检测能够明确病因，避免因影像检查的局限性导致疾病漏检。'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '诊断只是前提，治疗才是关键，精准诊断可指导治疗方向'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '例如癫痫患者主要治疗手段是服用抗癫痫药（Antiepileptiedrugs，AEDs），AEDs种类有很多，不同致病基因的疾病在药物应用上有各自的适应症与禁忌症。如：STXBP1基因突变引起的早发性癫痫性脑病适用左乙拉西坦；SCN2A基因突变引起的早发性癫痫性脑病需要大剂量的苯妥英；KCNT1基因突变引起的婴儿癫痫伴游走性局灶性发作应用FDA批准的钾通道拮抗剂奎尼丁有效， KCNT1基因突变引起的其他癫痫表型用奎尼丁则无效。这就是精准的重要意义。'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '另外精准诊断还可以避免无效治疗。遗传代谢病是由于基因突变，导致机体内代谢物质底物的堆积或产物的缺乏而表现出相应临床症状的一类疾病。遗传代谢病最常出现的就是神经系统的非特异性表现，如ALDH7A1基因突变引起的吡哆醇依赖性癫痫，则可用维生素B6替代抗癫痫药进行治疗；SLC19A3基因突变引起的硫胺素代谢障碍综合2型的癫痫表型可通过补充生物素治疗。这类疾病通常不需要用AEDs，应用AEDs治疗无效。精准诊断不仅可以避免无效治疗，还可避免因错用药物造成的不良后果的发生。'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '可判断疾病预后及预防'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '相同综合征，不同基因的预后判断。如West综合征，可由ARX、CDKL5、SPTAN1、STXBP等不同的基因引起，同样是West综合征，CDKL5基因预后良好，ADEs可完全缓解改善患者症状；ARX基因可能发展成为Lennox-Gastaut综合征，并且患儿90%以上有不同程度的精神运动发育迟缓。'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '相同基因，不同综合征的预后判断。同样是SCN1A基因，既是全面性癫痫伴热性惊厥附加症（GEFS+）的致病基因，也是Dravet 综合征的致病基因，两种疾病均以癫痫为主要表现。GEFS+表现为热性惊厥、典型或非典型失神发作、通常预后良好。而Dravet 综合征，则预后差，常会引起严重的智力损害。'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '精准诊断可以判断预后，确立预后差患者的潜在疾病并发症，进行预防性干预来改善预后。'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '提供准确复发风险评估及遗传咨询'
        }
      ]
    },
    {
      type: 'p5-genetic-value',
      children: [
        {
          text: '遗传咨询最重要的前提就是病因学诊断，精准的基因诊断需结合患者的病史、家族史、遗传学检测结果向患者及其家属提供准确的有关治疗、再生育优生选择、提供准确的复发风险评估。'
        }
      ]
    },
    {
      type: 'header3-genetic-krd',
      children: [
        {
          text: '附录一'
        }
      ]
    },
    {
      type: 'box-center-column',
      children: [
        {
          type: 'span-blod',
          children: [
            {
              text: 'ACMG致病性证据列表'
            }
          ]
        },
        {
          type: 'table-available',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-color-genetic-krd',
                  children: [
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '致病性证据'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-color-genetic-krd',
                  children: [
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '分类'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '非常强'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PVS1：当一个疾病的致病机制为功能丧失（LOF）时，无功能变异（无义突变、移码突变、经典±1或2的剪接突变、起始密码子变异、单个或多个外显子缺失）。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic-r4',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '强'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PS1：与先前已确定为致病性的变异有相同的氨基酸改变。例如：同一密码子，G>C或G>T改变均可导致缬氨酸→亮氨酸的改变。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PS2：患者的新发变异（Denovo），且无家族史（经双亲验证）。注：仅仅确认父母还不够，还需注意捐卵、代孕、胚胎移植的差错等情况。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PS3：体内、体外功能实验已明确会导致基因功能受损的变异。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PS4：变异出现在患病群体中的频率显著高于对照群体。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic-r6',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '中等'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PM1：位于热点突变区域，和/或位于已知无良性变异的关键功能域（如酶的活性位点）。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PM2：ESP数据库、千人数据库、EXAC数据库中正常对照人群中未发现的变异（或隐性遗传病中极低频位点）。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PM3：在隐性遗传病中，在反式位置上检测到致病变异（经家系验证）。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PM4：非重复区框内插入/缺失或终止密码子丧失导致的蛋白质长度变化（插入、缺失的碱基数是3的整倍数）。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PM5：新的错义突变导致氨基酸变化，此变异之前未曾报道，但是在同一位点，导致另外一种氨基酸的变异已经确认是致病性的，如：现在观察到的是Arg156Cys，而Arg156His是已知致病的。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PM6：未经父母样本验证的新发变异（Denovo）。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic-r5',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '支持证据'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PP1：突变与疾病在家系中共分离（在家系多个患者中检测到此变异）注：如果有更多的证据，可作为更强的证据。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PP2：对某个基因来说，如果这个基因的错义变异是造成某种疾病的原因，并且这个基因中良性变异所占的比例很小，在这样的基因中所发现的新的错义变异。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PP3：多种统计方法预测出该变异会对基因或基因产物造成有害的影响，包括保守性预测、进化预测、剪接位点影响等。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PP4：变异携带者的表型或家族史高度符合某种单基因遗传疾病。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `PP5：有可靠信誉来源的报告认为该变异为致病的，但证据尚不足以支持进行实验室独立评估。`
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'box-center-column',
      children: [
        {
          type: 'span-blod',
          children: [
            {
              text: 'ACMG良性证据列表'
            }
          ]
        },
        {
          type: 'table-available',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-color-genetic-krd',
                  children: [
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '良性证据'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-color-genetic-krd',
                  children: [
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '分类'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '独立证据'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BA1：ESP数据库、千人数据库、ExAC数据库中等位基因频率>5%的变异。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic-r4',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '强'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BS1：等位基因频率大于疾病发病率。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BS2：对于早期完全外显的疾病，在健康成年人中发现该变异（隐性遗传病发现纯合、显性遗传病发现杂合，或者X连锁半合子）。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BS3：在体内外实验中确认对蛋白质功能和剪接没有影响的变异。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BS4：在一个家系成员中缺乏共分离。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic-r7',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: '支持证据'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BP1：已知一个疾病的致病原因是由于某基因的截短变异，在此基因中所发现的错义变异。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BP2：在显性遗传病中又发现了另一条染色体上同一基因的一个已知致病变异，或者是任意遗传模式遗传病中又发现了同一条染色体上同一基因的一个已知致病变异。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BP3：功能未知重复区域内的缺失/插入，同时没有导致基因编码框改变。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BP4：多种统计方法预测出该变异会对基因或基因产物无影响，包括保守性预测、进化预测、剪接位点影响等。注：由于做预测时许多生物信息算法使用相同或非常相似的输入，每个算法不应该算作一个独立的标准。BP4在一个任何变异的评估中只能使用一次。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BP5：在已经有另一分子致病原因的病例中发现的变异。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BP6：有可靠信誉来源的报告认为该变异为良性的，但证据尚不足以支持进行实验室独立评估。`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `BP7：同义变异且预测不影响剪接。`
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'box-center-column',
      children: [
        {
          type: 'span-blod',
          children: [
            {
              text: 'ACMG致病性计算方法'
            }
          ]
        },
        {
          type: 'table-available',
          children: [
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic-r8',
                  children: [
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '致病的'
                        }
                      ]
                    },
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '(Pathogenic)'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `1个非常强(PVS)+≥1个强(PS)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `1个非常强(PVS)+≥2个中等(PM)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `1个非常强(PVS)+1个中等(PM)+1个支持(PP)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `1个非常强(PVS)+≥2个支持(PP)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `≥2个强(PS)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `1个强(PS)+≥3个中等(PM1)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `1个强(PS)+2个中等(PM)+≥2个支持(PP)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `1个强(PS)+1个中等(PM)+≥4个支持(PP)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic-r6',
                  children: [
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '可能致病的'
                        }
                      ]
                    },
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '(Likely pathogenic)'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `1个非常强(PVS)+1个中等(PM)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `1个强(PS)+1-2个中等(PM)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `1个强(PS)+≥2个支持(PP)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `≥3个中等(PM)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `2个中等(PM)+≥2个支持(PP)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `2个中等(PM)+≥2个支持(PP)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic-r2',
                  children: [
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '良性的'
                        }
                      ]
                    },
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '(Benign)'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `≥2个强(BS)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `≥2个强(BS)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic-r2',
                  children: [
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '可能良性的'
                        }
                      ]
                    },
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '(Likely benign)'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `1个强(BS)+1个支持(BP)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `≥2个支持(BP)`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic-r2',
                  children: [
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '意义不明确的'
                        }
                      ]
                    },
                    {
                      type: 'p4-center',
                      children: [
                        {
                          text: '(VUS)'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `不满足上述标准或`
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell-genetic',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `良性和致病标准相互矛盾`
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'signature-footer',
      children: [
        {
          text: formatDate(report.createdAt, 'YYYY-MM-DD') ?? '-'
        }
      ]
    }
  ]
}
